import { SiteBrand } from "@/data/brand"
import { LayoutMain } from "@/modules/layout/main"

export const Page404 = () => {
	return <LayoutMain Brand={SiteBrand}>Not Found</LayoutMain>
}
